import  { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

const SignIn = () => {

	const [formData, setFormData] = useState({
		email : '',
		password : ''
	});

	const navigate = useNavigate();

	const submitHandler  = () => {
		if(formData.email === "" || formData.password === ""){
			alert("Enter All Credentials");
		}else{
			if(formData.email === 'user@bharatrohan.in'  && formData.password === 'user2016'){
				localStorage.setItem('isLoggedIn', true)
				navigate('/dashboard');
			}else{
				alert("Credentials are not valid");
			}
		}
	}

	useEffect(() => {
		if(localStorage.getItem('isLoggedIn')){
			navigate('/')
		}
	},[])

  return (
	<div className="min-h-screen flex items-center justify-center" style={{backgroundImage : "url('assets/drone-new.jpg')"}}>

		<div className="absolute inset-0 bg-black bg-opacity-70 z-0"></div>

			<div className="w-[95%] md:w-full max-w-md bg-white bg-opacity-25 backdrop-blur-md rounded-2xl shadow-2xl p-8 space-y-6">
				<h2 className="text-2xl text-white text-center">Login</h2>
				
				<form className="space-y-5" onSubmit={submitHandler}>
					<div>
						<label className="block text-white text-sm font-medium">Email</label>
						<input type="email" placeholder="you@example.com" className="w-full mt-1 px-4 py-2 rounded-lg bg-white bg-opacity-20 text-white focus:outline-none focus:ring-2 focus:ring-green-950" onChange={(event) => setFormData({...formData, email : event.target.value})}/>
					</div>

					<div>
						<label className="block text-white text-sm font-medium">Password</label>
						<input type="password" placeholder="••••••••" className="w-full mt-1 px-4 py-2 rounded-lg bg-white bg-opacity-20 text-white focus:outline-none focus:ring-2 focus:ring-green-950" onChange={(event) => setFormData({...formData, password : event.target.value})}/>
					</div>

					<button type="submit" className="w-full py-2 bg-green-950 hover:bg-green-950 text-white font-semibold rounded-lg transition duration-200">
						Sign In
					</button>
				</form>
		</div>
		

	</div>
  )
}

export default SignIn